import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useRef, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import * as Yup from 'yup';
import { IOptionsProps } from "../../../Components/Form/Select/select.component";
import { useToast } from "../../../Hooks/ToasContext";
import { ICubageVariantAssociated } from "../../../Services/api/cubages-variants/cubages-variants.interface";
import { ICubageEntity } from "../../../Services/api/cubages/cubages.interface";
import { ICreatePricePoliciesPayload, ICreateRulesPoliciesPayload, IPricePoliciesEntity, IPricePoliciesRulesEntity, IUpdatePricePoliciesPayload, IUpdateRulesPoliciesPayload } from "../../../Services/api/price-policies/price-policies.interface";
import { IProductServiceEntity } from "../../../Services/api/products-services/products-services-interface";
import { IProductEntity } from "../../../Services/api/products/products.interface";
import { ListCategoriesUseCase } from "../../../Usecase/Categories/list-categories-usecase";
import { ListCubagesUseCase } from "../../../Usecase/Cubages/list-cubages-usecase";
import { CreatePricePoliciesUseCase } from "../../../Usecase/PricePolicies/create-price-policies-usecase";
import { ShowPricePoliciesUseCase } from "../../../Usecase/PricePolicies/show-price-policies-usecase";
import { CreatePricePoliciesRulesUseCase } from "../../../Usecase/PricePoliciesRules/create-price-policies-rules-usecase";
import { CreateProductUseCase } from "../../../Usecase/Products/create-product-usecase";
import { ShowProductUseCase } from "../../../Usecase/Products/show-product-usecase";
import { UpdateProductUseCase } from "../../../Usecase/Products/update-product-usecase";
import { ListProductsServiceUseCase } from "../../../Usecase/ProductsService/list-products-service-usecase";
import { ListServiceInfoOrdersUseCase } from "../../../Usecase/ServicesInfo/list-service-info-usecase";
import { IProductProps } from "../../Products/Form/create-products-hook";
import { UpdatePricePoliciesRulesUseCase } from "../../../Usecase/PricePoliciesRules/update-price-policies-rules-usecase";
import { DestroyPricePoliciesRulesUseCase } from "../../../Usecase/PricePoliciesRules/destroy-price-policies-rules-usecase";
import { UpdatePricePoliciesUseCase } from "../../../Usecase/PricePolicies/update-price-policies-usecase";

export interface IPricePolicy {
  id: string;
  minQuantity: number;
  discountPercentage: number;
}


  interface IUseCreatePricePoliciesProps {
    createProductUseCase: CreateProductUseCase
    listCubagesUseCase: ListCubagesUseCase
    listProductsServiceUseCase: ListProductsServiceUseCase
    listServiceInfoOrdersUseCase: ListServiceInfoOrdersUseCase
    showProductUseCase: ShowProductUseCase
    updateProductUseCase: UpdateProductUseCase
    listCategoriesUseCase: ListCategoriesUseCase
    createPricePoliciesUseCase: CreatePricePoliciesUseCase
    createPricePoliciesRulesUseCase: CreatePricePoliciesRulesUseCase
    showPricePoliciesUseCase: ShowPricePoliciesUseCase
    updatePricePoliciesRulesUseCase: UpdatePricePoliciesRulesUseCase
    destroyPricePoliciesRulesUseCase: DestroyPricePoliciesRulesUseCase
    updatePricePoliciesUseCase: UpdatePricePoliciesUseCase
}



const CreatePricePoliciesSchemaValidation = Yup.object().shape({
    name: Yup.string().required('Nome é obrigatório'),
   
  });




export function useCreatePricePolicies({ createProductUseCase, listCubagesUseCase, listProductsServiceUseCase, listServiceInfoOrdersUseCase, showProductUseCase, updateProductUseCase, listCategoriesUseCase, createPricePoliciesUseCase, createPricePoliciesRulesUseCase, showPricePoliciesUseCase, updatePricePoliciesRulesUseCase, destroyPricePoliciesRulesUseCase, updatePricePoliciesUseCase }: IUseCreatePricePoliciesProps){
   
    const [loading, setLoading] = useState(false)
    const [images, setImages] = useState<File[]>([]);
    const [showCategoriesModal, setShowCategoriesModal] = useState(false)
    const [categories,setCategories] = useState<IOptionsProps[]>([])
    // const [categories,setCategories] = useState<ICategoryEntity[]>([])
    // const [categoriesSelected,setCategoriesSelected] = useState<ICategoryEntity[]>([])
    const [categoriesSelected,setCategoriesSelected] = useState<IOptionsProps[]>([])
    const [showSEOModal, setShowSEOModal] = useState(false)
    const [showCubageModal, setShowCubageModal] = useState(false)
    const [showInternalCode, setShowInternalCode] = useState(false)
    const [showVariationsModal, setShowVariationsModal] = useState(false)
    const [internalCode, setInternalCode] = useState<{maskCode: string, internalName: string}>({maskCode: '', internalName: ''})
    const [variations,setVariations] = useState<Array<{
        variationType: string;
        values: string[];
    }>>([])
    const [cubagesList, setCubagesList] = useState<ICubageEntity[]>([])
    const [productsServicesList, setProductsServicesList] = useState<IProductServiceEntity[]>([])
    const [productsServicesOptions, setProductsServicesOptions] = useState<IOptionsProps[]>([])
    
    const [data, setData] = useState<IProductEntity>()
    const [cubagesSelected, setCubagesSelected] = useState<ICubageVariantAssociated[]>([])
    const [pricePolicies, setPricePolicies] = useState<Array<{
        id: string;
        minQuantity: number;
        discountPercentage: number;
    }>>([])
    const [showRules, setShowRules] = useState(false)
    const [pricePoliciyId, setPricePoliciyId] = useState<string>('')

    const [policies, setPolicies] = useState<IPricePoliciesRulesEntity[]>([]);
    const [addNewPricePolicy, setAddNewPricePolicy] = useState(false)
    const [policyToEdit, setPolicyToEdit] = useState<IPricePoliciesRulesEntity | null>(null)
    const [policyToDestroy, setPolicyToDestroy] = useState<IPricePoliciesRulesEntity | null>(null)
    

    const params = useParams()
    
    const navigate = useNavigate()

    const { handleSubmit, register, control, formState, watch, setValue, unregister, getValues } = useForm<IProductProps>({
        resolver: yupResolver(CreatePricePoliciesSchemaValidation)
      });

    const { errors } =  formState

    const { showToast } =  useToast()

    const dragAndDropRef = useRef<any>(null);

    const handleAction: SubmitHandler<ICreatePricePoliciesPayload> = async (values) => {
      
      try {
          setLoading(true)

          const payload : ICreatePricePoliciesPayload | IUpdatePricePoliciesPayload = {
            name: values.name,
            description: values?.description,
            policyId: pricePoliciyId
          }

          console.log("policies: ", policies)
          console.log("pricePoliciyId: ", pricePoliciyId)
      
          const storeResult = pricePoliciyId ? await updatePricePoliciesUseCase.handle(payload as IUpdatePricePoliciesPayload) : await createPricePoliciesUseCase.handle(payload);
          // const storeResult = await createPricePoliciesUseCase.handle(payload);

          if (storeResult.isFailure) {
          
          showToast(String(storeResult?.error?.error), 'error');
          return;
          }

          const response = storeResult.getValue()

          if(response?.id){
            setPricePoliciyId(response.id)
          }

          showToast(pricePoliciyId ? 'Política de Preço Editada' : 'Política de Preço Cadastrada', 'success');
          
      
         setShowRules(true)   
      } catch (error) {
        console.log("error: ", error)
          // toast({
          //   position: 'top-right',
          //   render: () => <ToastCustom type='fail' title='Erro' description={error.response?.data?.error ?? 'Erro ao logar. Por favor, tente novamente'} />,
          // });
      } finally {
          setLoading(false);
      }
    };


    const handleSelectCategories = (e: IOptionsProps) => {
      const existsCategory = categoriesSelected.find(category => category.value === e.value)
  
      if(existsCategory){
          const filtered = categoriesSelected?.filter(category => category.value !== e.value)
          setCategoriesSelected([...filtered])
      } else {
          setCategoriesSelected(prev => [...prev, e])
      }
      }

    const handleListCubages = async () => {
        
        try {
          setLoading(true)
          
          const listResult = await listCubagesUseCase.handle(1);
  
          if (listResult.isFailure) {
       
            showToast(String(listResult?.error?.error), 'error');
            return;
          }
  
         const list = listResult.getValue()
  
         if(list?.length){
            setCubagesList(list)
         }


        } catch (error) {
          console.log("error listCubages function: ", error)
        } finally {
          setLoading(false);
        }
    };

    const handleListProductsServices = async () => {
        
        try {
          setLoading(true)
          
          const listResult = await listProductsServiceUseCase.handle(1);
  
          if (listResult.isFailure) {
       
            showToast(String(listResult?.error?.error), 'error');
            return;
          }
  
         const list = listResult.getValue()
  
         if(list?.data?.length){
            const normalize = list.data.map(i => ({
                value: i.id,
                label: i.name
            }))

            setProductsServicesOptions(normalize)
            setProductsServicesList(list.data)
         }


        } catch (error) {
          console.log("error handleListProductsServices function: ", error)
        } finally {
          setLoading(false);
        }
    };

    const handleShowPricePolicy = async (policyId: string) => {
        
      try {
        setLoading(true)
        
        const showResult = await showPricePoliciesUseCase.handle(policyId);

        if (showResult.isFailure) {
          showToast(String(showResult?.error?.error), 'error');
          return;
        }

       const policy = showResult.getValue()

       if(policy?.id){
          setValue('name', policy.name)
          setValue('description', policy?.description)
          setShowRules(true)
          setPolicies(policy.rules || [])
          
       }

      } catch (error) {
        console.log("error handleShowPricePolicy function: ", error)
      } finally {
        setLoading(false);
      }
    };

    const handleDestroyPricePolicy = async () => {
      
      try {
        setLoading(true)
        
        const showResult = await destroyPricePoliciesRulesUseCase.handle({
          policyId: policyToDestroy?.pricePolicyId || '',
          ruleId: policyToDestroy?.id || ''
        });

        if (showResult.isFailure) {
          showToast(String(showResult?.error?.error), 'error');
          return;
        }

       showToast('Removido com sucesso.', 'success');
       setPolicyToDestroy(null)
       handleShowPricePolicy(pricePoliciyId || pricePoliciyId)

      } catch (error) {
        console.log("error handleDestroyPricePolicy function: ", error)
      } finally {
        setLoading(false);
      }
    };

    const handleRemoveTemporary = (cubageVariant: ICubageVariantAssociated) => {
      setCubagesSelected(cubagesSelected.filter((t) => t.cubageVariantId !== cubageVariant.cubageVariantId));
      setValue(`cubage-${cubageVariant?.cubageVariant?.cubage?.id}-variant-${cubageVariant.cubageVariantId}`, false)
    }

    const listCategories = async () => {
        
      try {
        setLoading(true)
        
        const listResult = await listCategoriesUseCase.handle({page: 1, getAll: true});

        if (listResult.isFailure) {
     
          showToast(String(listResult?.error?.error), 'error');
          return;
        }

       const list = listResult.getValue()

      //  if(list){
      //     setCategories(list.data)
          
      //  }

  
    
      } catch (error) {
        console.log("error listCategories function: ", error)
      } finally {
        setLoading(false);
      }
    };


    const handlePricePoliciesChange = (policies: Array<{
        id: string;
        minQuantity: number;
        discountPercentage: number;
    }>) => {
      setPricePolicies(policies);
    }

  

    const handleRemoveVariation = (variationType: string) => {
      setVariations(prev => prev.filter(v => v.variationType !== variationType));
    }

    const handleRemoveValue = (variationType: string, value: string) => {
      setVariations(prev => 
        prev.map(variation => {
          if (variation.variationType === variationType) {
            const updatedValues = variation.values.filter(v => v !== value);
            
            // Se não restaram valores, remove a variação inteira
            if (updatedValues.length === 0) {
              return null;
            }
            
            return { ...variation, values: updatedValues };
          }
          return variation;
        }).filter(Boolean) as Array<{ variationType: string; values: string[] }>
      );
    }

    const handleClosePricePolicyModal = () => {
      setAddNewPricePolicy(false)
      setPolicyToEdit(null)
    }

    useEffect(() => {
      if(params.policyId){
        handleShowPricePolicy(params.policyId)
        setPricePoliciyId(params.policyId)
      }
    },[params])

  

  const handleAddNewRulePricePolicy = async (payload: ICreateRulesPoliciesPayload | IUpdateRulesPoliciesPayload) => {
        
    try {
      setLoading(true)
      
      const showResult = policyToEdit?.id ? await updatePricePoliciesRulesUseCase.handle(payload as IUpdateRulesPoliciesPayload) : await createPricePoliciesRulesUseCase.handle(payload as ICreateRulesPoliciesPayload);

      if (showResult.isFailure) {
        showToast(String(showResult?.error?.error), 'error');
        return;
      }

      showToast(policyToEdit?.id ? 'Regra atualizada com sucesso' : 'Regra adicionada com sucesso', 'success');
      setAddNewPricePolicy(false)
      setPolicyToEdit(null)
      handleShowPricePolicy(pricePoliciyId || pricePoliciyId)

    
    } catch (error) {
      console.log("error handleAddNewRulePricePolicy function: ", error)
    } finally {
      setLoading(false);
    }
  };
      

    return {
        loading,
        handleSubmit,
        handleAction,
        register,
        errors,
        control,
        watch,
        
        handleSelectCategories,
   
        showCategoriesModal,
        setShowCategoriesModal,
        showSEOModal,
        setShowSEOModal,
        showCubageModal,
        setShowCubageModal,
        showInternalCode,
        setShowInternalCode,
        showVariationsModal,
        setShowVariationsModal,
        internalCode,
        setInternalCode,
        variations,
        setVariations,
        images,
        setImages,
        cubagesList,
        handleListCubages,
        categories,
        setCategories,
        dragAndDropRef,
        handleListProductsServices,
       
        productsServicesOptions,
        cubagesSelected,
        handleRemoveTemporary,

   
        listCategories,
        categoriesSelected,
        data,
        setCategoriesSelected,
        pricePolicies,
        handlePricePoliciesChange,
    
        handleRemoveVariation,
        handleRemoveValue,
        policies,
     

     
        showRules,
        setShowRules,
        addNewPricePolicy,
        setAddNewPricePolicy,
        policyToEdit,
        setPolicyToEdit,
        policyToDestroy,
        setPolicyToDestroy, 
        handleAddNewRulePricePolicy,
        pricePoliciyId,
        handleClosePricePolicyModal,
        handleDestroyPricePolicy
    }
}